<template>
  <v-dialog max-width="250px" v-model="dialog" @keydown.enter.prevent="save">
    <v-card>
      <v-card-title/>
      <v-card-text>
        <v-row dense>
          <v-autocomplete
              v-model="model"
              :items="values"
              item-text="name"
              item-value="id"
              label="Select Group:"
              hide-details
              return-object
          />
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" text @click="cancel">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="save">ADD</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {WorkerTeam} from "@/modules/redactor/models/worker/WorkerTeam";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export default {
  name: "r-worker-team-dropdown",
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: VueTypes.objectOf(WorkerTeam),
    rules: ViewRules.READONLY,
  }),
  computed: {
    values() {
      return RedactorUtils.getWorkerTeams();
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new WorkerTeam();
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    }
  }
}

</script>